import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class WarehouseProductContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;

  @jsonMember(Boolean)
  public readonly canBeLabelDownloaded!: boolean;

  @jsonMember(Boolean)
  public readonly canBeQuantityEdited!: boolean;
}
